<template>
  <b-modal id="clinic-show-product" class="clinic-show-product" ref="modal" :title="dialog_title" hide-footer>
    <show-barcode-scanner ref="scanner" @submit="barcodeScanned" submit="onCodeScanned"></show-barcode-scanner>
    <div class="form-group row">
      <div class="col-sm-12 mb-2">
        <strong class="mb-2">DATOS DE PRODUCTO</strong>
      </div>

      <div class="col-sm-2">
        <input v-model="code" type="text" class="form-control" id="show_product_code" readonly />
        <label for="show_product_code" class="wabident-info" data-trigger="tooltip" :title="product_id">Código</label>
      </div>

      <div class="col-sm-8">
        <input placeholder="Nombre del tratamiento" v-model="name" type="text" id="show_product_name"
          class="form-control" required />
        <label class="wabident-info" for="show_product_name">Nombre del tratamiento</label>
      </div>
      <div class="col-sm-2">
        <select v-model="disabled" name="icon" id="show_product_disabled" class="custom-select">
          <option :value="0">Activo</option>
          <option :value="1">Inactivo</option>
        </select>
        <label class="wabident-info" for="show_product_disabled">Estado</label>
      </div>
    </div>

    <div v-if="clinic_type == 'dental'" class="form-group row">
      <div class="col-sm-3">
        <select v-model="icon" name="icon" id="show_product_icon" class="custom-select">
          <option value>Sin icono</option>
          <option v-for="(icon, index) in product_icons" :key="index" :value="index">
            {{ icon.name }}
          </option>
        </select>
        <label for="show_product_icon" class="wabident-info">Icono</label>
      </div>
      <div class="col-sm-4">
        <select v-model="position" name="position" id="show_product_position" class="custom-select">
          <option value>Sin definir</option>
          <option value="up">Oclusal</option>
          <option value="inside">Palatino/Lingual</option>
          <option value="outside">Vestibular</option>
          <option value="both">Ambos</option>
          <option value="inside_root">Raíz Palatino/Lingual</option>
          <option value="outside_root">Raíz Vestibular</option>
          <option value="both_root">Raíz Ambos</option>
        </select>
        <label for="show_product_position" class="wabident-info">Posición icono</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-12 mb-2">
        <strong v-if="products_price_per_clinic">PRECIO GENERAL</strong>
        <strong v-else>PRECIO</strong>
      </div>

      <div class="col">
        <input v-model="price" id="show_product_price" type="number" class="form-control" />
        <label for="show_product_price" class="wabident-info">Precio Imp. Incluidos (€) <strong
            v-if="products_price_per_clinic"> Precio por defecto si no hay precio específico para
            clínica</strong></label>
      </div>

      <div class="col">
        <select name="vat" id="show_vat" v-model="vat" class="custom-select" required>
          <option :value="null">Elige</option>
          <option v-for="tax in clinic_taxes" :value="parseInt(tax.value)" :key="tax.id">{{ tax.name }}
          </option>
        </select>
        <label class="wabident-info" for="show_vat">Impuestos Aplicados</label>
      </div>

      <div v-if="products_availability_per_clinic" class="col-sm-12 my-2">
        <strong>DISPONIBILIDAD POR CLÍNICA</strong>
      </div>

      <div v-if="products_availability_per_clinic" class="col-sm-4" v-for="(name, index) in clinic_names" :key="name">
        <div class="form-check form-check-inline">
          <input v-model="product_availability[index]" class="form-check-input" type="checkbox"
            :id="'product_clinic_available_' + index" :value="'available'" />
          <label class="form-check-label" :for="'product_clinic_available_' + index">{{ name }}</label>
        </div>
      </div>

      <div v-if="products_price_per_clinic" class="col-sm-12 my-2">
        <strong>PRECIOS POR CLÍNICA</strong>
      </div>

      <div v-if="products_price_per_clinic" class="col-sm-4" v-for="(name, index) in clinic_names" :key="index">
        <div class="d-flex align-items-center justify-start">
          <label class="flex-shrink-0 flex-grow-1 mr-4" :id="'clinic_product_price_' + index">
            {{ name }}
          </label>
          <input :value="getClinicPrice(index)" @input="setClinicPrice(index, $event)"
            :id="'clinic_product_price_' + index" type="number" class="form-control wabident-small" />
        </div>
      </div>


      <div v-if="products_price_per_tariff" class="col-sm-12 my-2">
        <strong>TARIFAS DE PRECIOS</strong>
      </div>

      <div v-if="products_price_per_tariff" class="col-sm-4" v-for="(tariff, index) in tariff_names" :key="index">
        <div class="d-flex align-items-center justify-start">
          <label class="flex-shrink-0 flex-grow-1 mr-4" :id="'tariff_product_price_' + index">
            {{ tariff.name }}
          </label>
          <input :value="getTariffPrice(index)" @input="setTariffPrice(index, $event)"
            :id="'tariff_product_price_' + index" type="number" class="form-control wabident-small" />
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-12 mb-2">
        <strong class="mb-2">CATEGORIZACIÓN</strong>
      </div>

      <div class="col">
        <select name="type" id="show_type" v-model="type" class="custom-select" required>
          <option :value="null">Elige</option>
          <option value="treatment">Tratamiento</option>
          <option value="product">Producto</option>
        </select>
        <label class="wabident-info" for="show_type">Tipo</label>
      </div>
      <div class="col">
        <select name="type" id="show_type" v-model="category_id" class="custom-select" required>
          <option :value="null">Ninguna</option>
          <option v-for="(c, i) in categories" :key="i" :value="c.id">
            {{ c.name }}
          </option>
        </select>
        <label class="wabident-info" for="show_type">Familia / Categoría / Unidad Médica</label>
      </div>

      <div v-if="enable_product_stock" class="col">
        <select v-model="enable_stock" name="enable_stock" id="enable_stock" class="custom-select">
          <option :value="0">No</option>
          <option :value="1">Sí</option>
        </select>
        <label class="wabident-info" for="enable_stock">Activar stocks</label>
      </div>
    </div>

    <div class="row form-group" v-if="enable_product_stock && enable_stock">

      <div class="col-md-12 mb-2">
        <strong class="mb-2">GESTIÓN DE STOCK</strong>
      </div>

      <div class="col-md-3">
        <input v-model="cost" id="product_cost" type="number" class="form-control" />
        <label for="product_cost" class="wabident-info">Coste del producto (€)</label>
      </div>

      <div class="col-md-3">
        <input v-model="stock" id="product_stock" type="number" class="form-control" />
        <label for="product_stock" class="wabident-info">Cantidad en stock</label>
      </div>

      <div class="col-md-3">
        <select v-model="enable_stock_limit" name="enable_stock_limit" id="enable_stock_limit" class="custom-select">
          <option :value="false">No</option>
          <option :value="true">Sí</option>
        </select>
        <label class="wabident-info" for="enable_stock_limit">Activar límite de stock</label>
      </div>

      <div class="col-md-3" v-if="enable_stock_limit">
        <input v-model="custom_stock_limit" id="product_stock_limit" type="number" class="form-control" />
        <label for="product_stock_limit" class="wabident-info">Límite de stock personalizado</label>
      </div>
    </div>


    <div class="row form-group" v-if="enable_product_stock && enable_stock">
      <div class="col-md-12 mb-2">
        <strong class="mb-2">CODIGO DE BARRAS</strong>
      </div>

      <div class="col-md-10">
        <input v-model="barcode" type="text" class="form-control" id="show_product_barcode" />
        <label for="show_product_barcode" class="wabident-info">Código de Barras (Manual)</label>
      </div>
      <div class="col-md-2">
        <button @click="scanBarcode" class="btn btn-block btn-wabident-round">
          Escanear <i class="fas fa-search"></i>
        </button>
      </div>
    </div>

    <div class="row form-group">
      <div class="col">
        <strong class="mb-2">OTROS DATOS</strong>
      </div>
    </div>

    <div v-if="type == 'treatment'" class="row form-group">
      <div class="col">
        <select v-model="limit_sessions" name="limit_sessions" id="limit_sessions" class="custom-select">
          <option :value="0">No</option>
          <option :value="1">Sí</option>
        </select>
        <label class="wabident-info" for="limit_sessions">Activar Bono</label>
      </div>

      <div class="col" v-if="limit_sessions">
        <input v-model="max_sessions" id="max_sessions" type="number" class="form-control" />
        <label for="max_sessions" class="wabident-info">Sesiones</label>
      </div>
    </div>

    <div class="form-group row">
      <div v-if="type == 'treatment'" class="col-md-3">
        <input v-model="default_duration" id="default_duration" type="number" class="form-control" />
        <label for="default_duration" class="wabident-info">Duración del Tratamiento (Min)</label>
      </div>
      <div class="col">
        <wabident-color-picker v-model="colors"></wabident-color-picker>
        <label class="wabident-info">Color en Agenda</label>
      </div>
    </div>

    <div class="form-group row mt-5">
      <div class="col text-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"></button>
        <button :disabled="is_loading" type="button" @click="onSubmit" class="btn btn-primary btn-wabident">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar Tratamiento</span>
          <span v-else>Crear Tratamiento</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      code: "",
      icon: "",
      position: "",
      disabled: 0,
      price: 0,
      vat: 0,
      type: null,
      prices: {},
      product_availability: {},
      category_id: null,
      is_editing: false,
      is_loading: false,
      product: null,
      enable_stock: 0,
      stock: 0,
      enable_stock_limit: false,
      custom_stock_limit: 0,
      barcode: null,
      cost: null,
      product_hierarchy: [],
      variants: {},
      max_sessions: 0,
      limit_sessions: 0,
      default_duration: 0,
      colors: {
        hex: "#000000",
      },
      product_icons: {
        absent: {
          name: "Ausente",
          icon: "icon-wabident-absent",
        },
        brackets: {
          name: "Brackets",
          icon: "icon-wabident-brackets",
        },
        cavity: {
          name: "Caries",
          icon: "icon-wabident-caries",
        },
        carilles: {
          name: "Carillas",
          icon: "icon-wabident-carillas",
        },
        corona: {
          name: "Corona",
          icon: "icon-wabident-corona",
        },
        endodoncy: {
          name: "Endodoncia",
          icon: "icon-wabident-endodoncia",
        },
        extraction: {
          name: "Extracción",
          icon: "icon-wabident-extraccion",
        },
        fracture: {
          name: "Fractura",
          icon: "icon-wabident-fractura",
        },
        implant: {
          name: "Implante",
          icon: "icon-wabident-implante",
        },
        prothesis: {
          name: "Prótesis",
          icon: "icon-wabident-protesis",
        },
        restore: {
          name: "Restauración",
          icon: "icon-wabident-restauracion",
        },
        multiple: {
          name: "Múltiple",
          icon: "icon-wabident-multiple",
        },
      },
    };
  },
  computed: {
    product_id() {
      return this.product ? 'ID:' + this.product.id : 'ID: N/D';
    },
    is_admin() {
      return this.current_role == 'admin';
    },
    clinic_names() {
      return this.clinic ? this.clinic.clinic_names : {};
    },
    tariff_names() {
      if (!this.clinic) {
        return {};
      }
      return this.clinic.tariffs;
    },
    categories() {
      var ret = [];

      this.product_hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });

      return ret;
    },
    clinic_taxes() {
      if (!this.clinic) return [];
      return this.clinic.taxes;
    },
    enable_product_stock() {
      if (!this.clinic) return false;
      return this.clinic.config.products_enable_stock && this.type == 'product';
    },
    products_price_per_clinic() {
      if (!this.clinic) return false;
      return Boolean(this.clinic.config.products_price_per_clinic);
    },
    products_price_per_tariff() {
      if (!this.clinic) return false;
      return Boolean(this.clinic.config.products_price_per_tariff);
    },
    products_availability_per_clinic() {
      if (!this.clinic) return false;
      return Boolean(this.clinic.config.products_availability_per_clinic) && this.is_admin;
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    dialog_title() {
      if (this.type == 'product') {
        return this.is_editing ? "Modificar Producto" : "Nuevo Producto";
      }
      return this.is_editing ? "Modificar Tratamiento" : "Nuevo Tratamiento";
    },
    ...mapGetters(["errorwindow", "msgwindow", "clinic", "current_role"]),
  },
  methods: {
    addCategory(cat, ret, level) {
      let prefix = '⁠–'.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: prefix + cat.name,
        parent_id: cat.parent_id,
        level: level
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    showNew() {
      this.is_editing = false;
      this.product = null;
      this.position = "";
      this.disabled = 0;
      this.name = "";
      this.icon = "";
      this.price = 0;
      this.vat = 0;
      this.type = 'treatment';
      this.category_id = null;
      this.variants = [],
        this.enable_stock = 0;
      this.stock = 0;
      this.cost = null
      this.barcode = null;
      this.enable_stock_limit = false;
      this.custom_stock_limit = 0;
      this.max_sessions = 0;
      this.limit_sessions = 0;
      this.colors = { hex: "#000000" };
      this.default_duration = 0;
      this.getNewProductCode();
      this.getCategories();
      this.$refs.modal.show();
      this.prices = this.getDefaultPrices(null);
      this.product_availability = this.getDefaultAvailability(null);
    },
    showEdit(product) {
      this.is_editing = true;
      this.position = product.position || "";
      this.name = product.name || "";
      this.icon = product.icon || "";

      if (this.products_price_per_clinic) {
        this.price = product.default_price || "";
      } else {
        this.price = product.price || "";
      }

      this.code = product.code;
      this.vat = Number.parseFloat(product.vat) || 0;
      this.type = product.type;
      this.disabled = product.disabled;
      this.product = product;
      this.category_id = product.product_category_id;
      this.enable_stock = product.enable_stock ? 1 : 0;
      this.stock = product.stock;
      this.max_sessions = product.max_sessions;
      this.limit_sessions = product.limit_sessions;
      this.default_duration = product.default_duration;
      this.enable_stock_limit = Boolean(product.custom_stock_limit);
      this.custom_stock_limit = product.custom_stock_limit;
      this.cost = product.cost;
      this.barcode = product.barcode;

      if (product.color) {
        this.colors = { hex: product.color };
      } else {
        this.colors = { hex: "#000000" };
      }

      if (product.variants) {
        this.variants = product.variants;
      } else {
        this.variants = [];
      }

      this.prices = this.getDefaultPrices(product);
      this.product_availability = this.getDefaultAvailability(product);

      this.getCategories();
      this.$refs.modal.show();
    },
    getDefaultPrices(product) {
      if (!this.clinic) {
        return {};
      }

      let default_prices = {};

      // Construct default values - per clinic
      if (this.products_price_per_clinic) {
        default_prices.by_clinic = {};
        Object.keys(this.clinic_names).forEach(clinic_id => {
          default_prices['by_clinic'][clinic_id] = null;
        });
      }

      // Construct default values - per tariff
      if (this.products_price_per_tariff) {
        default_prices.by_tariff = {};
        Object.keys(this.tariff_names).forEach(tariff_id => {
          default_prices['by_tariff'][tariff_id] = null;
        });
      }

      // Assign values if existing
      if (product && WabiDent.isObject(product.prices)) {
        const by_clinic = product.prices.by_clinic;
        if (WabiDent.isObject(by_clinic)) {
          default_prices.by_clinic = by_clinic;
        }

        const by_tariff = product.prices.by_tariff;
        if (WabiDent.isObject(by_tariff)) {
          default_prices.by_tariff = by_tariff;
        }
      }

      return default_prices;
    },
    getDefaultAvailability(product) {
      // Generate a default map allowing always for every clinic
      let default_availability = {};
      Object.keys(this.clinic_names).forEach((clinic_id) => {
        default_availability[clinic_id] = true;
      });

      if (!product) {
        return default_availability;
      }

      // Mix in the availabilities for current product
      let product_avails = product.availabilities || [];
      product_avails.forEach((avail) => {
        default_availability[avail.clinic_id] = (avail.status == 'available');
      });

      return default_availability;
    },
    onSubmit() {
      if (this.is_editing) {
        this.modifyProduct();
      } else {
        this.createNewProduct();
      }
    },
    addAttribute() {
      this.variants.push({
        name: 'Atributo ' + this.variants.length,
        values: [],
      });
    },
    removeAttribute(i) {
      this.errorwindow.show('Confirmación', 'Esto borrará todas las variantes.¿Estás segur@?', 'Borrar', 'Cancelar', () => {
        this.variants.splice(i, 1);
      });
    },
    addVariant(i) {
      this.variants[i].values.push("");
    },
    removeVariant(i, j) {
      this.variants[i].values.splice(j, 1);
    },
    setClinicPrice(clinic_id, event) {
      if (WabiDent.isObject(this.prices.by_clinic)) {
        this.prices.by_clinic[clinic_id] = Number(event.target.value);
      }
    },
    setTariffPrice(tariff_id, event) {
      if (WabiDent.isObject(this.prices.by_tariff)) {
        this.prices.by_tariff[tariff_id] = Number(event.target.value);
      }
    },
    getClinicPrice(clinic_id) {
      return WabiDent.isObject(this.prices.by_clinic) ? this.prices.by_clinic[clinic_id] : null;
    },
    getTariffPrice(tariff_id) {
      return WabiDent.isObject(this.prices.by_tariff) ? this.prices.by_tariff[tariff_id] : null;
    },
    validate() {
      console.log('validate')
      let messages = [];

      if (!this.name || this.name == '') {
        messages.push('El nombre del producto no puede estar vacío');
      }

      if (!this.type) {
        messages.push('Debes elegir tipo: Producto o Tratamiento ');
      }

      if (this.vat == null) {
        messages.push('Debes elegir un tipo de impuesto, elige "Exento" si el tratamiento o produco van libres de impuestos');
      }

      if (messages.length > 0) {
        this.errorwindow.show('Error', '<p>Por favor corrige los siguientes errores antes de guardar:<ul><li>' + messages.join('<li>') + '</ul></p>');
        return false;
      }

      return true;
    },
    modifyProduct() {
      if (!this.is_loading) {
        if (!this.validate()) {
          return;
        }

        this.is_loading = true;
        let params = {
          name: this.name,
          code: this.code,
          position: this.position,
          icon: this.icon,
          price: this.price,
          disabled: this.disabled,
          vat: this.vat,
          type: this.type,
          product_category_id: this.category_id,
          variants: this.variants,
          enable_stock: this.enable_stock,
          stock: this.stock,
          custom_stock_limit: this.enable_stock_limit ? this.custom_stock_limit : 0,
          max_sessions: this.max_sessions,
          limit_sessions: this.limit_sessions,
          default_duration: this.default_duration,
          color: this.colors.hex,
          barcode: this.barcode,
          cost: this.cost,
          prices: this.prices,
          availability: this.product_availability,
        };
        axios
          .post(`/product/${this.product.id}`, params)
          .then((response) => {
            this.$emit("submit", response.data);
            this.msgwindow.success("Tratamiento modificado con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] modifyProduct ", err);
            this.msgwindow.error("Error modificando tratamiento!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createNewProduct() {
      if (!this.is_loading) {

        if (!this.validate()) {
          return;
        }

        this.is_loading = true;
        let params = {
          name: this.name,
          code: this.code,
          position: this.position,
          icon: this.icon,
          price: this.price,
          disabled: this.disabled,
          vat: this.vat,
          type: this.type,
          product_category_id: this.category_id,
          variants: this.variants,
          enable_stock: this.enable_stock,
          stock: this.stock,
          custom_stock_limit: this.enable_stock_limit ? this.custom_stock_limit : 0,
          max_sessions: this.max_sessions,
          limit_sessions: this.limit_sessions,
          default_duration: this.default_duration,
          color: this.colors.hex,
          barcode: this.barcode,
          cost: this.cost,
          prices: this.prices,
          availability: this.product_availability,
        };
        axios
          .post("/product", params)
          .then((response) => {
            this.$emit("submit", response.data);
            this.msgwindow.success("Tratamiento creado con éxito");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] createNewProduct ", err);
            this.msgwindow.error("Error creando tratamiento!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    onDelete() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(`/product/${this.product.id}`, { _method: "delete" })
          .then((response) => {
            this.msgwindow.success("Tratamiento borrado con éxito");
            this.$emit("submit");
            this.$refs.modal.hide();
          })
          .catch((err) => {
            console.log("[ERR] onDelete", err);
            this.msgwindow.error("Error borrando tratamiento");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    getCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.product_hierarchy = response.data;
        })
        .catch((err) => {
          console.log("[ERR] getCategories", err);
          this.msgwindow.error("Error buscando categorías de productos");
        });
    },
    getNewProductCode() {
      axios
        .get("/product/code")
        .then((response) => {
          this.code = response.data;
        })
        .catch((err) => {
          console.log("[ERR] getNewProductcode", err);
          this.msgwindow.error("Error obteniendo el código de tratamiento");
        });
    },
    scanBarcode() {
      this.$refs.scanner.show();
    },
    barcodeScanned(code) {
      this.barcode = code;
    }
  },
};
</script>

<style lang="scss">
#clinic-show-product {

  .modal-dialog {
    max-width: 50%;
  }

  &__section-row {
    border-top: 1px var(--theme-grey-disabled) solid;
    padding-top: 10px;
  }

  &__remove-variant {
    padding: 0 10px;
    height: 37px;
    border-radius: 0;
    color: var(--theme-color-absent);
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--theme-color);
    }
  }
}
</style>
